import { useEffect, useState } from "react";
import { Bell, X } from "lucide-react";

const STORAGE_KEY = "hf_notification_prompt_dismissed";

export default function NotificationPrompt() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !("Notification" in window)) return;
    if (Notification.permission === "default" && !localStorage.getItem(STORAGE_KEY)) {
      // Delay slightly so prompt doesn't compete with page load
      const t = setTimeout(() => setShow(true), 3500);
      return () => clearTimeout(t);
    }
  }, []);

  const enable = async () => {
    try {
      const perm = await Notification.requestPermission();
      if (perm === "granted") {
        new Notification("🎬 Hifireels notifications enabled!", {
          body: "We'll keep you posted on new opportunities, rewards & viral reels.",
          icon: "/favicon.ico",
        });
      }
    } catch {}
    localStorage.setItem(STORAGE_KEY, "1");
    setShow(false);
  };

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-20 left-3 right-3 z-[70] animate-in slide-in-from-bottom-5" data-testid="notif-prompt">
      <div className="rounded-2xl bg-gradient-to-br from-[#00E5FF]/15 to-[#FF2A5F]/10 border border-[#00E5FF]/40 backdrop-blur-lg p-3.5 shadow-2xl">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-xl bg-[#00E5FF]/20 flex items-center justify-center flex-shrink-0">
            <Bell className="w-5 h-5 text-[#00E5FF]"/>
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-outfit font-extrabold text-sm">Get notified about new opportunities 🎁</div>
            <p className="text-[11px] text-white/70 mt-0.5">Goldly rewards, viral reels, live invites & weekly insights.</p>
          </div>
          <button onClick={dismiss} data-testid="notif-prompt-dismiss" className="p-1 rounded-full hover:bg-white/10 flex-shrink-0">
            <X className="w-4 h-4 text-white/60"/>
          </button>
        </div>
        <div className="flex gap-2 mt-3">
          <button onClick={dismiss} data-testid="notif-prompt-later"
            className="flex-1 py-2 rounded-full text-xs font-bold bg-white/5 border border-white/10 text-white/70">
            Later
          </button>
          <button onClick={enable} data-testid="notif-prompt-enable"
            className="flex-1 py-2 rounded-full text-xs font-extrabold bg-[#00E5FF] text-black active:scale-95">
            Enable notifications
          </button>
        </div>
      </div>
    </div>
  );
}
